import script from "./EntityCards.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityCards.vue?vue&type=script&setup=true&lang=js"

import "./EntityCards.vue?vue&type=style&index=0&id=3dda4718&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dda4718"]])

export default __exports__